/*
  Empty-cart review strip (snippets/sk-empty-cart.liquid).

  The strip is a CSS scroll-snap row, so it swipes natively without this
  file. This adds what CSS cannot: moving on by itself every few seconds,
  keeping the dots in step with the strip, jumping when a dot is tapped, and
  holding still while someone reads, hovers, swipes or tabs through it.

  Everything is delegated from the document and state is kept per strip in a
  WeakMap, because the drawer replaces its markup on every cart change. The
  file is loaded as an external script (from snippets/cart-drawer.liquid and
  sections/main-cart-items.liquid) since the storefront's instant-loader app
  never runs inline ones.
*/
(() => {
  if (window.__skEmptyCartReviews) return;
  window.__skEmptyCartReviews = true;

  const ROOT = ".sk-empty-cart__reviews[data-rotating]";
  const TRACK = ".sk-empty-cart__slides";
  const INTERVAL = 6000;
  // How long a swipe, tap or scroll by the customer holds the strip still.
  const HOLD = 12000;
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const canHover = window.matchMedia("(hover: hover)");
  const state = new WeakMap();

  const stateOf = (root) => {
    if (!state.has(root)) state.set(root, { lastMove: Date.now(), holdUntil: 0, autoUntil: 0 });
    return state.get(root);
  };

  // Distance between the starts of two slides: the slide width plus the gap.
  const pitch = (track) => {
    const [first, second] = track.children;
    if (!first) return 1;
    return second ? second.offsetLeft - first.offsetLeft : first.offsetWidth || 1;
  };

  const currentIndex = (track) => Math.round(track.scrollLeft / pitch(track));

  function markDots(root, index) {
    root.querySelectorAll("[data-sk-review-dot]").forEach((dot) => {
      const current = String(Number(dot.dataset.skReviewDot) === index);
      if (dot.getAttribute("aria-current") !== current) dot.setAttribute("aria-current", current);
    });
  }

  function goTo(root, index) {
    const track = root.querySelector(TRACK);
    if (!track || !track.children.length) return;
    const count = track.children.length;
    const target = ((index % count) + count) % count;
    const entry = stateOf(root);
    // Scroll events from this move are the script's, not the customer's.
    entry.autoUntil = Date.now() + 1200;
    entry.lastMove = Date.now();
    track.scrollTo({
      left: target * pitch(track),
      behavior: reducedMotion.matches ? "auto" : "smooth",
    });
    markDots(root, target);
  }

  function hold(root) {
    const entry = stateOf(root);
    entry.holdUntil = Date.now() + HOLD;
    entry.lastMove = Date.now();
  }

  // Checked every second rather than on one fixed six-second beat, so a
  // strip always gets its full interval after it appears or is let go.
  window.setInterval(() => {
    const now = Date.now();
    document.querySelectorAll(ROOT).forEach((root) => {
      const entry = stateOf(root);
      const drawer = root.closest("cart-drawer");
      const idle =
        reducedMotion.matches ||
        document.hidden ||
        (drawer && !drawer.classList.contains("active")) ||
        (canHover.matches && root.matches(":hover")) ||
        Boolean(root.querySelector(":focus-visible"));
      if (idle) {
        entry.lastMove = now;
        return;
      }
      if (now < entry.lastMove + INTERVAL || now < entry.holdUntil) return;
      const track = root.querySelector(TRACK);
      if (track) goTo(root, currentIndex(track) + 1);
    });
  }, 1000);

  // Scroll does not bubble, so it is caught on the way down.
  document.addEventListener(
    "scroll",
    (event) => {
      const track = event.target;
      if (!(track instanceof Element) || !track.matches(TRACK)) return;
      const root = track.closest(ROOT);
      if (!root) return;
      if (Date.now() > stateOf(root).autoUntil) hold(root);
      markDots(root, currentIndex(track));
    },
    { capture: true, passive: true },
  );

  document.addEventListener(
    "pointerdown",
    (event) => {
      const root = event.target instanceof Element && event.target.closest(ROOT);
      if (root) hold(root);
    },
    { passive: true },
  );

  document.addEventListener("click", (event) => {
    const dot = event.target instanceof Element && event.target.closest("[data-sk-review-dot]");
    if (!dot) return;
    const root = dot.closest(ROOT);
    if (!root) return;
    hold(root);
    goTo(root, Number(dot.dataset.skReviewDot));
  });
})();
